import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {
  Intro,
  function1, function1_result,
  function2, function2_result, 
  function3, function3_result,
  function4, function4_result, function4_popup,
  error,
} from 'pages';

class App extends Component {
  render() {
    return (
      <div>
        {/* 구체적인 URI는 추후에 수정 */}
        <Switch>
          <Route exact path="/" component={Intro} />
          <Route exact path="/function1" component={function1} />
          <Route exact path="/function1/result" component={function1_result} />
          <Route exact path="/function2" component={function2} />
          <Route exact path="/function2/result" component={function2_result} />
          <Route exact path="/function3" component={function3} />
          <Route exact path="/function3/result" component={function3_result} />
          <Route exact path="/function4" component={function4} />
          <Route exact path="/function4/result" component={function4_result} />
          <Route exact path="/function4/popup" component={function4_popup} />
          <Route exact path="/error" component={error} />
        </Switch>
      </div>
    )
  }
}

export default App;
